import { InquiryState } from './inquiries.types'

export default (): InquiryState => ({
  data: {},
  filters: {}
})
